<script>
    import {state, pastDrops,claimables} from "../stores/contracts";
    import {wallet_injected, unlock_requested, unlock, unlocked} from "../stores/wallet";


    import {navigateTo} from 'svelte-router-spa'
    import About from "../windows/About.svelte";
    import Add from "../windows/Add.svelte";
    import Claimable from "../windows/Claimable.svelte";
    import Drop from "../windows/Drop.svelte";
    import Drops from "../windows/Drops.svelte";
    import Home from "../windows/Home.svelte";
    import RecentClaims from "../windows/RecentClaims.svelte";
    import Icon from "../components/Icon.svelte";

    export let currentRoute;

    let openWindows = {
        about: false,
        add: false,
        claimable: false,
        drop: false,
        drops: false,
        home: false,
        past: false,
    }
    let minimised = {
        about: false,
        add: false,
        claimable: false,
        drop: false,
        drops: false,
        home: false,
        past: false,
    }
    let windowList = [
        "about",
        "drops",
        "add",
        "claimable",
        "past",
        // "drop",
    ];

    let windowHeight = [];
    let dropWindow = {
        tokenAddress: "",
        dropTokenId: 0,
    }
    let activeWindow = "";

    let first = "";
    let second = "";
    let third = "";

    let noParams = false;


    // let state = 0;

    let iconLabels = {
        about: "ABOUT",
        add: "ADD",
        claimable: "CLAIMABLE",
        drop: "DROP",
        drops: "DROPS GALLERY",
        past: "PAST DROPS",
    }

    function unlockWallet(){
        if($wallet_injected && !$unlocked && !$unlock_requested){
            unlock();
        }
    }

    // console.log(currentRoute);
    // console.log(currentRoute.name);
    //
    // switch(currentRoute.name){
    //     case "/":
    //     case "/drops":
    //         first = "drops";
    //         break;
    //     case "/drop":
    //         first = "drop";
    //         break;
    //     case "/about":
    //         first = "about";
    //         break;
    //     case "/add":
    //         first = "add";
    //         break;
    //     case "/past":
    //         first = "past";
    //         break;
    //     case "/claimable":
    //         first = "claimable";
    //         break;
    //
    //
    // }

    let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

    if (currentRoute.namedParams.firstParam) {
        // tokenAddress = cleanAddress(currentRoute.namedParams.dropTokenAddress);
        first = currentRoute.namedParams.firstParam;
        // state = 1;
    } else if (!isMobile) {
        // noParams = true;
        first = "drops";
        // state = 0;
    }
    if (first === "/" && !isMobile) {
        first = "drops";
        // noParams = true;
        // state = 0;

    }
    if (currentRoute.namedParams.secondParam) {
        // dropTokenId = parseInt(currentRoute.namedParams.dropTokenId);
        second = currentRoute.namedParams.secondParam;
        // state = 2;
    }
    if (currentRoute.namedParams.thirdParam) {
        // dropTokenId = parseInt(currentRoute.namedParams.dropTokenId);
        third = currentRoute.namedParams.thirdParam;
        // state = 3;
    }
    if (first) {
        // console.log(first, second, third);
        if (Object.keys(openWindows).includes(first)) {
            if (first === "drop") {
                openDrop(second, third);
            } else {
                openWindow(first);
            }
        } else {
            console.log("window not found")
        }
    }
    //
    // console.log("---");
    // console.log(first);
    // console.log(second);
    // console.log(third);


    // function none() {
    //     navigateTo("");
    //     state = 0;
    // }
    //
    // function one() {
    //     navigateTo("/one");
    //     state = 1;
    // }
    //
    // function two() {
    //     navigateTo("/one/two");
    //     state = 2;
    // }
    //
    // function three() {
    //     navigateTo("/one/two/three");
    //     state = 3;
    // }

    function openWindow(window) {
        // console.log("open:", window);
        openWindows[window] = true;
        minimised[window] = false;
        let index = windowHeight.indexOf(window);
        if (index > -1) {
            windowHeight.splice(index, 1);
        }
        windowHeight.push(window);
        windowHeight = windowHeight;
        navigateTo("/" + window);
    }

    function closeWindow(window) {
        openWindows[window] = false;
        let index = windowHeight.indexOf(window);
        if (index > -1) {
            windowHeight.splice(index, 1);
        }
        windowHeight = windowHeight;
        if (windowHeight.length > 0) {
            navigateTo("/" + windowHeight[windowHeight.length - 1]);
        }
    }

    function openDrop(tokenAddress, dropTokenId) {
        dropWindow.tokenAddress = tokenAddress;
        dropWindow.dropTokenId = dropTokenId;
        openWindow("drop");
        navigateTo("/drop/" + tokenAddress + "/" + dropTokenId);
    }

    function minimise(window){
        minimised[window] = true;
        navigateTo("/");

    }

    function injectedOnly(window){
        return (
            ["add","claimable"].includes(window)

        );
    }

    function finishAdd(tokenAddress,dropTokenId){
        closeWindow("add");
        openDrop(tokenAddress,dropTokenId);
    }
    let walletIconLabel = "";

    let showClaimable = false;
    let showPast = false;
    $:{
        showPast = $pastDrops.length > 0;
        showClaimable = Object.keys($claimables).length > 0;

        if (windowHeight.length === 0) {
            activeWindow = "";
        } else {
            activeWindow = windowHeight[windowHeight.length - 1];
        }
        // openWindowList = [];
        // for(let window in openWindows){
        //     if(openWindows[window] && window !== "home"){
        //         openWindowList.push(window);
        //     }
        // }
    }

    // <!--$:{-->
    // <!--    openWindows;-->
    // <!--}-->

    // setInterval(()=>{
    //     console.log(openWindows);
    //  },1000);

    let walletIconLabels = {
        initial: "CONNECT WALLET",
        loading: "CONNECTING...",
        loaded: "CONNECTED",
        network: "ERROR: NETWORK",
        error: "WALLET ERROR"
    }


</script>

<style>
    .desktop {
        width:100%;
        height:100%;
        /*background-image: url("/images/Vaporwave_Background.png");*/
        /*width:100%;*/
        /*height: 100%;*/
    }
    .icons{
        /*width:100vw;*/
        height:100vh;
        padding-left: 30px;
        padding-top: 30px;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        align-content: flex-start;

        column-gap: 50px;
        row-gap: 10px;
    }
</style>

<div class="desktop">
    <div class="icons">
        <Icon image="drops" unclickable={true}/>
        <Icon image="metamask"  label="{walletIconLabels[$state]}" onClick={unlockWallet}
            unclickable={$state !== "initial"}
              blocked={$state !== "initial"}
              state={$state}
        />
        <!--{#if $state === "initial"}-->
        <!--    <Icon image="metamask" label="CONNECT WALLET" onClick={unlockWallet}/>-->
        <!--{:else if $state === "loading"}-->
        <!--    <Icon image="metamask" label="CONNECTING..." unclickable={true}/>-->
        <!--{:else if $state === "loaded"}-->
        <!--    <Icon image="metamask" label="CONNECTED" unclickable={true}/>-->
        <!--{:else if $state === "network"}-->
        <!--    <Icon image="metamask" label="ERROR: NETWORK" unclickable={true}/>-->
        <!--{:else if $state === "error"}-->
        <!--    <Icon image="metamask" label="WALLET ERROR" unclickable={true}/>-->
        <!--{/if}-->

        <!-- {#if
            !( (window === "claimable" && !showClaimable)
                ||
             (window === "past" && !showPast) )
        } -->


        {#each windowList as window}
            <Icon label="{iconLabels[window]}"
                    isOpen={!minimised[window] && openWindows[window]}
                    onClick={()=>{openWindow(window)}}
                    blocked={ ($state !== "loading" &&  $state !== "loaded" && injectedOnly(window)) || (window === "claimable" && !showClaimable)}
                    title={ (window === "claimable" && !showClaimable) ? "The connected wallet does not hold a POW NFT Atom which Triggers any CLAIM" : "" }
            />
        {/each}

    </div>


<!--    <div><button on:click={()=>{openWindow('about')}}>Open About</button><button on:click={()=>{closeWindow('about')}}>Close about</button><button on:click={()=>{openWindow('drops')}}>Open drops</button><button on:click={()=>{closeWindow('drops')}}>Close drops</button></div>-->



    {#if openWindows.about && !minimised.about}
        <About
                depth={windowHeight.indexOf("about")}
                toFront={()=>{openWindow('about')}}
                minimise={()=>{minimise('about')}}
                active={activeWindow === "about"}
        />
    {/if}
    {#if openWindows.add && !minimised.add}
        <Add
            finishAdd={finishAdd}
                depth={windowHeight.indexOf("add")} toFront={()=>{openWindow('add')}}
              minimise={()=>{minimise('add')}}  active={activeWindow === "add"} />
    {/if}
    {#if openWindows.claimable && !minimised.claimable}
        <Claimable  depth={windowHeight.indexOf("claimable")}  toFront={()=>{openWindow('claimable')}}
                    minimise={()=>{minimise('claimable')}} active={activeWindow === "claimable"}
                    openDrop={openDrop}
        />
    {/if}

    {#if openWindows.drop && !minimised.drop}

        <Drop
                toFront={()=>{
                    openDrop(dropWindow.tokenAddress,dropWindow.dropTokenId)
                }}
                minimise={()=>{minimise('drop')}}
                depth={windowHeight.indexOf("drop")}
                tokenAddress="{dropWindow.tokenAddress}"
                dropTokenId="{dropWindow.dropTokenId}"
                active={activeWindow === "drop"}

        />
    {/if}
    {#if openWindows.drops && !minimised.drops}
<!--        drops-->
        <Drops depth={windowHeight.indexOf("drops")}
               minimise={()=>{minimise('drops')}}
               toFront={()=>{openWindow('drops')}}
               active={activeWindow === "drops"}
               openDrop={openDrop}
        />
    {/if}
    {#if openWindows.home && !minimised.home}
        <Home depth={windowHeight.indexOf("home")}

              minimise={()=>{minimise('home')}}
              toFront={()=>{openWindow('home')}}
              active={activeWindow === "home"}
              openWindow={openWindow}
        />
    {/if}
    {#if openWindows.past && !minimised.past}
        <RecentClaims  depth={windowHeight.indexOf("past")}
                       minimise={()=>{minimise('past')}}
                       toFront={()=>{openWindow('past')}}
                       active={activeWindow === "past"} />
    {/if}


<!--    <div>{state}</div>-->

<!--    {#if noParams}-->
<!--        <div>none</div>-->
<!--    {:else}-->
<!--        <div>{first}</div>-->
<!--        <div>{second}</div>-->
<!--        <div>{third}</div>-->
<!--    {/if}-->

<!--    <button on:click={none}>-->
<!--        None-->
<!--    </button>-->
<!--    <button on:click={one}>-->
<!--        One-->
<!--    </button>-->
<!--    <button on:click={two}>-->
<!--        Two-->
<!--    </button>-->
<!--    <button on:click={three}>-->
<!--        Three-->
<!--    </button>-->

</div>

